import { Col, Form, Modal, Row } from "antd";
import AButton from "core/presentation/components/Button";
import AText from "core/presentation/components/Text";
import ATitle from "core/presentation/components/Title";
import { useNavigate } from "react-router-dom";
import { typography } from "theme/Typography";
import OrderSummary from "./Summary";
import ScheduleOrders from "./ScheduledOrders";
import RecentOrders from "./RecentOrders";
import { AverageRate } from "./AverageRate";
import OnTimeDeliveryRate from "./OnTimeDeliveryRate";
import { TotalOrdersChart } from "./TotalOrdersChart";
import { LogisticsCost } from "./LogisticCosts";
import { useAppDispatch, useAppSelector } from "core/presentation/store/hooks";
import { userThunks } from "user/presentation/store/userSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { orderThunks } from "order/presentation/store/orderSlice";
import Loader from "core/presentation/components/Loader";
import { FailedIcon } from "../../../../../assets/icons/Failed";

const ShipperMainDashboard = () => {
  const { userProfile, dashboardData } = useAppSelector((state) => state.user);
  const userRole = userProfile?.user?.roles[0]?.roleCode;

  // Use company name if exists, otherwise use first name
  const companyName = userProfile?.user?.company?.companyName;
  const displayName = companyName || `${userProfile?.user?.firstName}`;
  
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [additionalModal, setAdditionalModal] = useState<boolean>(false);

  const isAdditionalInfoSkipped: boolean =
    userProfile?.user?.isAdditionalInfoSkipped;

  const handleCreateOrder = () => {
    if (!!isAdditionalInfoSkipped && userProfile?.user?.address === null) {
      return setAdditionalModal(true);
    }
    navigate("/orders/create");
  };

  const hasPermission = ['order:list_all', 'order:list'].some(p =>
    userProfile?.user?.permissions?.includes(p)
  );

  const getShipmentDashboardDetails = async () => {
    await dispatch(userThunks.getDashboardThunk({ role: "ROLE_SHIPPER" }));
  };

  const getStaffDashboardDetails = async () => {
    await dispatch(userThunks.getDashboardThunk({ role: "ROLE_STAFF" }));
  };

  useEffect(() => {
    if(userRole === "SHIPPER") {
      getShipmentDashboardDetails();
    } else  {
      getStaffDashboardDetails();
    }
  }, []);
  
  if (!dashboardData) {
    return <Loader />;
  }
  
  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <ATitle
            content={`Welcome Back, ${displayName}`}
            style={{ fontSize: typography.fontSizes.threexl }}
          />
          <AText>Track, manage and view your shipments.</AText>
        </div>

        {(userProfile?.user?.permissions?.includes('bid_request:create')) && (
          <Form.Item style={{ marginRight: "8px" }}>
          <AButton
            type="primary"
            color="default"
            padding="0 20px"
            onClick={handleCreateOrder}
            fontSize="16px"
            fontWeight={600}
            height="36px"
          >
            + Create New Request
          </AButton>
        </Form.Item>
        )}
      </div>

      <OrderSummary />
      {/* <ScheduleOrders /> */}
      <Row gutter={[20, 20]}>
        <Col md={24}>{/* <AverageRate /> */}</Col>
        {/* <Col md={8}>
          {" "}
          <OnTimeDeliveryRate />
        </Col> */}
      </Row>
      <Row gutter={[20, 20]}>
        <Col md={12}>
          {" "}
          {/* <LogisticsCost /> */}
          <OnTimeDeliveryRate />
        </Col>
        <Col md={12}>
          <TotalOrdersChart materials={dashboardData?.materials} />
        </Col>
      </Row>
      {hasPermission && <RecentOrders />}
      <Modal
        open={additionalModal}
        onCancel={() => {
          setAdditionalModal(false);
        }}
        width={400}
        // closeIcon={null}
        centered
        footer={[
          <div style={{ display: "flex", flexDirection: "row" }}>
            <AButton
              key="cancelButton"
              onClick={() => {
                setAdditionalModal(false);
              }}
              fullwidth
              type="default"
              mode="darkoutlined"
            >
              Cancel
            </AButton>
            <AButton
              key="continueButton"
              onClick={() => {
                navigate("/additional-information");
              }}
              fullwidth
              type="primary"
            >
              Proceed
            </AButton>
          </div>,
        ]}
      >
        <div className="modal-body">
          <FailedIcon />
          <p
            style={{
              fontSize: typography.fontSizes.lg,
              fontWeight: typography.fontWeights.semibold,
              lineHeight: "28px",
            }}
          >
            Additional Information Required
          </p>
          <p
            style={{
              fontSize: typography.fontSizes.sm,
              fontWeight: typography.fontWeights.normal,
              lineHeight: "20px",
            }}
          >
            Please complete the additional information to access and bid on an
            order.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default ShipperMainDashboard;